import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import logoPandin from "./img/logo_wide.png";

function Sidebar() {
  const { i18n, t } = useTranslation();

  var sideBarItems = t("Sidebar", { returnObjects: true });

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <div className="sidebar-pandin">
      <div className="container-fluid d-flex flex-column align-items-start">
        <img src={logoPandin} alt="Pandin Logo" width={200} height={40} />
        <div className="" id="Sidebar">
          <ul className="pan flex-column list-unstyled">
            <li className="pan-item">
              <a className="pan-link active" href="/dashboard">
                <i className="bi bi-speedometer2"></i> Dashboard
              </a>
            </li>
            <li className="pan-item">
              <a
                className="pan-link"
                href="#pagesSubmenu"
                data-bs-toggle="collapse"
                aria-expanded="false"
              >
                <i className="bi bi-files"></i> {sideBarItems["Pages"]}
              </a>
              <ul className="list-unstyled" id="pagesSubmenu">
                <li>
                  <a className="pan-link" href="/pages/home">
                    {sideBarItems["Home"]}
                  </a>
                </li>
                <li>
                  <a className="pan-link" href="/pages/image-converter">
                    {sideBarItems["ImageConverter"]}
                  </a>
                </li>
                <li>
                  <a className="pan-link" href="/pages/password-generator">
                    {sideBarItems["PasswordGenerator"]}
                  </a>
                </li>
                <li>
                  <a className="pan-link" href="/pages/qr-code-generator">
                    {sideBarItems["QRCodeGenerator"]}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
